import { useAction, useAtom } from "@reatom/npm-react";
import { StartExportTaskRequestDto } from "definitions/exporter";
import { SubmitHandler } from "react-hook-form";
import { API } from "src/api.ts";
import { PAGINATION_DEFAULT_STATE } from "src/constants/pagination";
import { toastHandler, truncateStart } from "src/util";

import { exportTasksFilterAtom } from "../../store/fetchers";
import { ExportTaskFormValues } from "./ExportTasksForm.types";

export const useExportTasksForm = () => {
  const setFilter = useAction(exportTasksFilterAtom);
  const [isLoading, setLoading] = useAtom(false);

  const createExportTask: SubmitHandler<
    ExportTaskFormValues & { id: string }
  > = (data) => {
    setLoading(true);

    const payload: StartExportTaskRequestDto = data;

    API.exporterQueueApi
      .exportControllerStartExportTask(payload)
      .then(() => {
        toastHandler.success({
          name: "createExportTask",
          title: data.cronTask ? "Запуск регулярной задачи" : "Запуск задачи",
          content: `${data.cronTask ? "Регулярная задача" : "Задача"} ${truncateStart(data.id)} запущена`,
        });
      })
      .finally(() => {
        setLoading(false);
        setFilter((prev) => ({ ...prev, page: PAGINATION_DEFAULT_STATE.page }));
      });
  };

  return { isLoading, createExportTask };
};
